<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Live View Site {{ id }} Safe ID {{ safes[0].crypto_idnum }} <v-spacer />{{ userhasaccess(id) }}
            </div>
            <div class="display-2 font-weight-light">
              {{ sitedetails.address }}, {{ sitedetails.city }} {{ sitedetails.zipcode }}  {{ sitedetails.timezone }} Open: {{ sitedetails.time_open }}  Close: {{ sitedetails.time_close }}
            </div>
            <div class="display-2 font-weight-light">
              <b>Current Total: {{ currentsum }}</b>
            </div>
          </template>
          <v-row>
            <v-spacer />
            <v-btn
              color="warning"
              to="/CCSiteReports"
            >
              Return
            </v-btn>
          </v-row>
          <v-row>
            <v-col
              lg="8"
            >
              <apexchart
                v-if="!calculating"
                type="bar"
                height="300"
                :options="chartOptions"
                :series="safesums"
              />
              <v-data-table
                :headers="headers"
                hide-default-footer
                :items="safe_data"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title><b>Current Note Values</b></v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:no-data>
                  <div class="display-2 font-weight-light">
                    Sorry, no messages to display for Smart Safe ID {{ id }}
                  </div>
                  <br>
                </template>
              </v-data-table>
              <v-data-table
                :headers="depheaders"
                :items="deposit_data"
                :items-per-page="5"
                sort-by="timestamp"
                sort-desc
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title><b>Deposits</b></v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />

                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ format_time(item.timestamp) }}
                </template>
                <template v-slot:[`item.sum`]="{ item }">
                  {{ format_amt(item.sum) }}
                </template>
                <template v-slot:no-data>
                  <div class="display-2 font-weight-light">
                    <v-btn
                      small
                      class="mr-2"
                      color="primary"
                      :to="'/ReportDeposit/' + id"
                    >
                      Deposit Reports
                    </v-btn>
                  </div>
                  <br>
                </template>
              </v-data-table>
            </v-col>
            <v-col
              lg="4"
            >
              <div class="title-1 font-weight-light">
                Connection Status
              </div>
              <v-progress-linear
                indeterminate
                :color="statuscolor"
              />
              <br>
              <br>
              <div class="title-1 font-weight-light">
                Note Capacity  {{ notecount }} / {{ maxnotes }}
              </div>
              <v-progress-linear
                v-model="currentcapacity"
                height="10"
                color="deep-purple darken-1"
              />
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
              <v-divider class="mt-3" />
              <br>
              <br>
              <v-data-table
                :headers="manualheaders"
                :items="safe_manual"
                :search="search"
                height="300"
                dense
                sort-by="timestamp"
                sort-desc
                :items-per-page="5"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title><b>Manual Deposits/Checks</b></v-toolbar-title>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    />
                    <v-spacer />
                  </v-toolbar>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ item.amount/100 }}
                </template>
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ format_time(item.timestamp) }}
                </template>
                <template v-slot:no-data>
                  <div class="display-2 font-weight-light">
                    Sorry, No data to display
                  </div>
                  <br>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-divider class="mt-3" />
        </base-material-card>

        <div class="py-3" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format } from 'date-fns-tz'

  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'CashBalance',
    props: ['id'],

    data () {
      return {
        valueDeterminate: 50,
        valueNoteCapacity: this.currentnotecount / 1000,
        capacitycolor: 'brown',
        loading: false,
        sitedetails: '',
        search: '',
        calculating: true,
        options: {
          chart: {
            sparkline: {
              enabled: true
            }
          },
          colors: ['#00aedb'],
          stroke: {
            width: 2,
            curve: 'smooth'
          },
          fill: {
            gradient: {
              shade: 'light',
              type: 'diagonal1',
              shadeIntensity: 0.5,
              gradientToColors: ['#3BA22F'],
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 90, 100],
              colorStops: []
            }
          },
          xaxis: {
            crosshairs: {
              width: 1
            }
          },
          yaxis: {
            min: 0
          },
          title: {
            text: '$135,965',
            offsetX: 0,
            style: {
              fontSize: '24px',
              cssClass: 'apexcharts-yaxis-title'
            }
          },
          subtitle: {
            text: 'Revenue',
            offsetX: 0,
            style: {
              fontSize: '14px',
              cssClass: 'apexcharts-yaxis-title'
            }
          }
        },
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Current Notes',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return value
              }
            },
            min: 0,
            showAlways: true,
            tickAmount: 2,
          },
          xaxis: {
            categories: []
          }
        },
        series: [{
          name: 'cashinbyday',
          data: []
        }],
        transactionheaders: [
          {
            text: 'TimeStamp',
            align: 'left',
            sortable: true,
            value: 'timestamp',
          },
          { text: 'Message', value: 'message' }
        ],
        manualheaders: [
          { text: 'Local Site Time', value: 'localtime', align: 'center' },
          { text: 'User ID', value: 'useridnum', align: 'center' },
          { text: 'Deposit ID', value: 'userdepositid', align: 'center' },
          { text: 'Total', value: 'amount', align: 'center' }
        ],
        depheaders: [
          { text: 'Local Site Time', value: 'localtime', align: 'center' },
          { text: 'User ID', value: 'useridnum', align: 'center' },
          { text: 'Deposit ID', value: 'userdepositid', align: 'center' },
          { text: 'Ones', value: 'ones', align: 'center' },
          { text: 'Fives', value: 'fives', align: 'center' },
          { text: 'Tens', value: 'tens', align: 'center' },
          { text: 'Twenties', value: 'twenties', align: 'center' },
          { text: 'Fifties', value: 'fifties', align: 'center' },
          { text: 'Hundreds', value: 'hundreds', align: 'center' },
          { text: 'Sum', value: 'sum', align: 'center' }
        ],
        headers: [
          { text: 'Ones', value: 'ones', align: 'center' },
          { text: 'Fives', value: 'fives', align: 'center' },
          { text: 'Tens', value: 'tens', align: 'center' },
          { text: 'Twenties', value: 'twenties', align: 'center' },
          { text: 'Fifties', value: 'fifties', align: 'center' },
          { text: 'Hundreds', value: 'hundreds', align: 'center' },
        ],
        valid: true,
        graphsums: [],
        graphdays: [],
        notetable: [],
        currentnotecount: 0,
        machinesum: 0,
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        activeBtn: 1,
        grow: true,
        cashinperunit: '',
        lastheartbeat: 0,
        trans: [],
        dep_data: [],
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {
      menuforstatus () {
        if (this.$store.getters.user.status === 'storemanager') {
          return []
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return []
        } else if (this.$store.getters.user.status === 'corporate') {
          return [
            {
              text: 'Deposit Events',
              value: 'deposits',
              color: 'green',
              icon: 'mdi-account-cash-outline',
              nav: '/ReportDeposit/'
            },
            {
              text: 'Cash in Transit',
              value: 'cit',
              color: 'purple',
              icon: 'mdi-transfer-right',
              nav: '/ReportTransit/'
            },
            {
              value: 'cashin',
              text: 'Daily Volume',
              color: 'orange',
              icon: 'mdi-calendar-multiple',
              nav: '/ReportCashin/'
            },
            {
              value: 'monthly',
              text: 'Monthly Volume',
              color: 'red',
              icon: 'mdi-chart-areaspline',
              nav: '/ReportMonth/'
            }
          ]
        } else if (this.$store.getters.user.status === 'admin') {
          return [
            {
              text: 'Deposit Events',
              value: 'deposits',
              color: 'green',
              icon: 'mdi-account-cash-outline',
              nav: '/ReportDeposit/'
            },
            {
              text: 'Cash in Transit',
              value: 'cit',
              color: 'purple',
              icon: 'mdi-transfer-right',
              nav: '/ReportTransit/'
            },
            {
              value: 'cashin',
              text: 'Daily Volume',
              color: 'orange',
              icon: 'mdi-calendar-multiple',
              nav: '/ReportCashin/'
            },
            {
              value: 'monthly',
              text: 'Monthly Volume',
              color: 'red',
              icon: 'mdi-chart-areaspline',
              nav: '/ReportMonth/'
            }
          ]
        }
      },
      currentsum () {
        return numeral(this.machinesum).format('$0.00')
      },
      safe_trans () {
        this.trans = this.$store.getters.safetransactions.reverse()
        this.$log.debug('SAFE DATA IS ', this.trans)
        return this.trans
      },
      notecount () {
        return this.currentnotecount
      },
      maxnotes () {
        let max = 2000
        if (this.sitedetails.noteCapacity) {
          max = this.sitedetails.noteCapacity
        }
        return max
      },
      currentcapacity () {
        this.$log.debug('current note count cap is', (this.currentnotecount / 2000) * 100)
        return (this.currentnotecount / this.sitedetails.noteCapacity) * 100
      },
      statuscolor () {
        let color = 'green'
        let safeid = this.safes[0].crypto_idnum
        let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
        this.$log.debug(rec, this.id)
        if (rec) {
          let now = Date.now()
          let mContact = moment(rec.heartbeat)
          let mNow = moment(now)
          let duration = moment.duration(mNow.diff(mContact))
          this.$log.debug('minutes since last contact', duration.asMinutes())
          let MINUTES_CONSIDERED_OFFLINE = 60
          // this.lastheartbeat = moment(rec.heartbeat)
          // this.$log.debug('last heartbeat ', this.lastheartbeat)
          if (duration.asMinutes() <= MINUTES_CONSIDERED_OFFLINE) {
            color = 'green'
          }
          if (duration.asMinutes() >= MINUTES_CONSIDERED_OFFLINE) { // 60  minutes
            color = 'red'
          }
        }
        this.$log.debug('color is ', color)

        return color
      },
      safesums () {
        this.chartOptions.xaxis.categories = ['Ones', 'Fives', 'Tens', 'Twenties', 'Fifties', 'Hundreds']
        this.$log.debug('NOTE TABLE IS ', this.notetable)
        return [{ name: 'Notes', data: [...this.notetable] }]
      },
      safe_manual () {
        let man_dep = this.$store.getters.getManualDeposits
        this.$log.debug('MAN IS ', this.$store.getters.getManualDeposits)
        for (let dep in man_dep) {
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' est format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/Denver'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = man_dep[dep].timestamp
            let timeZone = 'America/Chicago'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          Object.assign(man_dep[dep], { localtime: output })
        }
        this.$log.debug(man_dep)
        return man_dep
      },
      safe_data () {
        this.items = []
        this.machinesum = 0
        // lets cut this thing up to how we want it
        let sitedata = this.$store.getters.balancevalues
        let graphdata = []
        let ones = 0
        let fives = 0
        let tens = 0
        let twenties = 0
        let fifties = 0
        let hundreds = 0
        let sum = sitedata.total
        this.currentnotecount = sitedata.bills
        for (let index in sitedata.values) {
          if (sitedata.values[index].denom === 1) {
            ones = sitedata.values[index].count
          } else if (sitedata.values[index].denom === 5) {
            fives = sitedata.values[index].count
          } else if (sitedata.values[index].denom === 10) {
            tens = sitedata.values[index].count
          } else if (sitedata.values[index].denom === 20) {
            twenties = sitedata.values[index].count
          } else if (sitedata.values[index].denom === 50) {
            fifties = sitedata.values[index].count
          } else if (sitedata.values[index].denom === 100) {
            hundreds = sitedata.values[index].count
          }
          this.calculating = false
        }
        graphdata = []
        this.items = []
        graphdata.push({
          ones: ones,
          fives: fives,
          tens: tens,
          twenties: twenties,
          fifties: fifties,
          hundreds: hundreds,
          sum: sum
        })
        this.machinesum = sum
        this.items = graphdata
        this.notetable = [ones, fives, tens, twenties, fifties, hundreds]
        // for each day count the note types
        // for each day get the sum of the notes
        // return this.items
        this.loading = false
        return this.items
      },
      deposit_data () {
        this.depdata = this.$store.getters.userdeposits
        for (let deposit in this.depdata) {
          let depnotes = this.depdata[deposit].notes
          let count_ones = 0
          let count_fives = 0
          let count_tens = 0
          let count_twenties = 0
          let count_fifties = 0
          let count_hundreds = 0
          let sum = 0
          this.$log.debug(' LOCAL FUNC ', this.sitedetails)
          let output
          if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.depdata[deposit].timestamp
            let timeZone = 'America/New_York'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' est format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.depdata[deposit].timestamp
            let timeZone = 'America/Chicago'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.depdata[deposit].timestamp
            let timeZone = 'America/Denver'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          }
          
          else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.depdata[deposit].timestamp
            let timeZone = 'Europe/London'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' GMT format is ', output)
          } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
            // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
            let locdate = this.depdata[deposit].timestamp
            let timeZone = 'America/Los_Angeles'
            let zonedDate = utcToZonedTime(locdate, timeZone)
            // zonedDate could be used to initialize a date picker or display the formatted local date/time

            // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
            let pattern = 'yyyy-MM-dd HH:mm:ss'
            output = format(zonedDate, pattern, { timeZone })
            this.$log.debug(' PST format is ', output)
          }
          //          let loctime = moment(this.items[deposit].timestamp).tz("America/New_York").format('YYYY-MM-DD HH:mm:ss')
          // Object.assign(this.items[deposit], {localtime: loctime })
          Object.assign(this.depdata[deposit], { localtime: output })

          Object.assign(this.depdata[deposit], { ones: numeral().format('0.00') })
          Object.assign(this.depdata[deposit], { fives: numeral().format('0.00') })
          Object.assign(this.depdata[deposit], { tens: numeral().format('0.00') })
          Object.assign(this.depdata[deposit], { twenties: numeral().format('0.00') })
          Object.assign(this.depdata[deposit], { fifties: numeral().format('0.00') })
          Object.assign(this.depdata[deposit], { hundreds: numeral().format('0.00') })
          for (let index in depnotes) {
            if (this.depdata[deposit].notes[index].denom === 1) {
              count_ones = this.depdata[deposit].notes[index].count
              Object.assign(this.depdata[deposit], { ones: numeral(count_ones).format('0.00') })
            } else if (this.depdata[deposit].notes[index].denom === 5) {
              count_fives = this.depdata[deposit].notes[index].count
              Object.assign(this.depdata[deposit], { fives: numeral(count_fives * 5).format('0.00') })
            } else if (this.depdata[deposit].notes[index].denom === 10) {
              count_tens = this.depdata[deposit].notes[index].count
              Object.assign(this.depdata[deposit], { tens: numeral(count_tens * 10).format('0.00') })
            } else if (this.depdata[deposit].notes[index].denom === 20) {
              count_twenties = this.depdata[deposit].notes[index].count
              this.$log.debug('TWENTIES IS ', count_twenties)
              Object.assign(this.depdata[deposit], { twenties: numeral(count_twenties * 20).format('0.00') })
            } else if (this.depdata[deposit].notes[index].denom === 50) {
              count_fifties = this.depdata[deposit].notes[index].count
              Object.assign(this.depdata[deposit], { fifties: numeral(count_fifties * 50).format('0.00') })
            } else if (this.depdata[deposit].notes[index].denom === 100) {
              count_hundreds = this.depdata[deposit].notes[index].count
              Object.assign(this.depdata[deposit], { hundreds: numeral(count_hundreds * 100).format('0.00') })
            }
          }
          sum = (count_ones * 1) + (count_fives * 5) + (count_tens * 10) + (count_twenties * 20) + (count_fifties * 50) + (count_hundreds * 100)
          Object.assign(this.depdata[deposit], { sum: sum })
        }

        // lets cut this thing up to how we want it
        // get note count
        // get the days in the array
        // get the sums in the array
        // get the days in the array

        // return this.items
        this.$log.debug(' depdata is ', this.depdata)
        return this.depdata
      },
      currentsafes () {
        let oursafes = this.$store.getters.safesstatus
        this.$log.debug('SAFES ARE ', this.$store.getters.safesstatus)
        return oursafes
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.graphsums = []
      this.graphdays = ''
      this.id = this.$route.params.id
      if (this.$route.params.id === 'Rainbow 1369 (DOTS)') {
        this.id = 'Rainbow 1369'
      }
      this.getsitemap(this.id)
      this.sitedetails = this.$store.getters.loadedSites.find(location => this.id === location.idnum)

      // this.$store.dispatch('loadsafetransactions', this.$route.params.id)
    },
    beforeDestroy () {
      this.$store.dispatch('stoprealtimebalance', this.safes)
      this.$store.dispatch('stoprealtimeuserdeposits', this.safes)
      this.$store.dispatch('stoprealtimemanualdeposits', this.safes)

      // this.$store.dispatch('resetsafetransactions')
    },
    methods: {
      log () {
        // this.$store.dispatch('loadsafetransactions', this.safes[0].crypto_idnum)
        // this.$store.dispatch('loadunituserdeposits', this.safes[0])
        // this.$store.dispatch('loadunitmanualdeposits', this.safes[0])

        // this.items = this.$store.getters.cashinvalues
        // this.$log.debug('cheating ', this.items)
      },
      gettopurl (nav) {
        let url = nav + this.id
        return url
      },
      userhasaccess (id) {
        return
        if (this.$store.getters.user.status === 'admin') {
          return ' You have been allowed access to this site '
        }
        let site = this.$store.getters.loadedSites.find(function (site) {
          if (site.idnum === id) {
            this.$log.debug(' found it', site.address)
            return site
          }
        })
        if (!site.allowedusers) {
          return ' You have NOT been allowed access to this site '
        }
        this.$log.debug('does user ', this.$store.getters.user, ' have access?')
        if (site.allowedusers.includes(this.$store.getters.user.email)) {
          return ' You have been allowed access to this site '
        }
        this.$log.debug('we have site details ', site)
        return ' You have NOT been allowed access to this site '
      },
      getsitemap (machineid) {
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.idnum === machineid) {
            if (value.siteunitsprofile) {
              let shop = {
                idnum: key,
                safeids: value.siteunitsprofile
              }
              this.location = shop
              this.safes = shop.safeids
              this.$store.dispatch('initrealtimebalance', this.safes)
              this.$store.dispatch('initmanualdepositlistener', this.safes)
              this.$store.dispatch('inituserdepositlistener', this.safes)

              this.$log.debug('GETTING TRANS FOR ', this.safes[0])
              // this.$store.dispatch('loadsafetransactions', this.safes[0].crypto_idnum)
              this.$store.dispatch('loadunituserdeposits', this.safes[0])
              this.$store.dispatch('loadunitmanualdeposits', this.safes[0])

              // now go get the data for these sites in the shop array
              //
            }
          }
        }
      },
      getlocationdetails (locationid) {
        this.$log.debug('locaiton id ', locationid, ' site list is ', this.$store.getters.loadedSites)
        let site = this.$store.getters.loadedSites.find(function (site) {
          if (site.idnum === locationid) {
            this.$log.debug(' found it', site)
          }
          return site.idnum === locationid
        })
        return site.address + ' ' + site.city
      },
      initialize () {
        let reportdata = this.$store.getters.safetransactions

        this.items = this.$store.getters.safesstatus
      },
      format_time (ts) {
        return moment(ts).format('YYYY-MM-DD, HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
